import { TCurrentUserState } from '~/context/User'

export const getUserUuid = () => {
  const parseData: TCurrentUserState = JSON.parse(localStorage.getItem('@doris:user') || '{}')
  return parseData?.uuid || ''
}
